import { useCallback } from 'react';
import { App, Form } from 'antd';

import { useForm } from 'antd/es/form/Form';

import { useTranslation } from 'react-i18next';
import { useStore } from 'zustand';
import { useCreateRegionalCalendarMutation, CalendarInputName, calendarStore } from 'entities/calendar';

const useCreateRegionalCalendar = (countryId: string): (() => void) => {
  const { t } = useTranslation();
  const { mutateAsync: createRegionalCalendarMutate } = useCreateRegionalCalendarMutation(countryId);

  const { modal } = App.useApp();
  const [form] = useForm<{ name: string }>();
  const selectedYear = useStore(calendarStore, (state) => state.selectedYear);

  const openCreateModal = useCallback((): void => {
    const instance = modal.confirm({
      title: t('Calendar:calendarsTable.createRegionalCalendar.title'),
      centered: true,
      closable: true,
      maskClosable: true,
      okButtonProps: { htmlType: 'submit' },
      cancelButtonProps: { htmlType: 'reset' },
      okText: t('Shared:saveBtn.text'),
      width: 450,
      icon: null,
      onOk: () => {
        return Promise.reject();
      },
      afterClose: () => {
        form.resetFields();
      },
      modalRender: (dom) => (
        <Form
          form={form}
          data-testid="create-regional-calendar-form"
          onFinish={({ name }) => {
            const trimmedName = name.trim();
            instance.update({ okButtonProps: { loading: true } });
            createRegionalCalendarMutate(
              { countryId, name: trimmedName, year: selectedYear.toString() },
              {
                onSettled: () => instance.destroy(),
                onError: () => instance.update({ okButtonProps: { loading: false } }),
              },
            );
          }}
        >
          {dom}
        </Form>
      ),
      content: <CalendarInputName />,
    });
  }, [modal, t, form, createRegionalCalendarMutate, countryId, selectedYear]);

  return openCreateModal;
};

export { useCreateRegionalCalendar };
